import { getCurrentLanguage } from './current-language'

let recaptachaResponse = ''

export const getRecaptchaResponse = (): string => {
  return recaptachaResponse
}

const recaptachaVerifyCallback = (response): void => {
  recaptachaResponse = response
}

const recaptchaApiLoaded = (): void => {
  window.grecaptcha.render(document.querySelector<HTMLDivElement>('#recaptcha'), {
    sitekey: '6Lf1x4MlAAAAAJlW__puwa-RCZpJ8WevEOLkeqAL',
    callback: recaptachaVerifyCallback,
    theme: 'light',
  })
}

export const loadRecaptcha = (): void => {
  if (!document.getElementById('recaptchaScript')) {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?onload=recaptchaApiLoaded&render=explicit&hl=${getCurrentLanguage()}`
    script.defer = true
    script.setAttribute('id', 'recaptchaScript')
    document.head.append(script)
  }
}

export const recaptachaReset = (): void => {
  window.grecaptcha.reset()
  recaptachaResponse = ''
}

const initCaptcha = () => {
  window.recaptchaApiLoaded = recaptchaApiLoaded
}

export default initCaptcha
